module.exports = __webpack_public_path__ + "787ecfb93de35ab6a8035755bd98efdd.svg";